export default "__VITE_ASSET__CEKbFOc6__"